import { useEffect } from 'react'
import * as PIXI from 'pixi.js'
import { Live2DModel } from 'pixi-live2d-display/lib/cubism4';

window.PIXI = PIXI

Live2DModel.registerTicker(PIXI.Ticker)

function Live2DAvatar() {
  useEffect(() => {
    const app = new PIXI.Application({
      view: document.getElementById('canvas'),
      autoStart: true,
      height: 500,
      width: 370,
      transparent: true,
    //  resizeTo: window,
    })

    Live2DModel.from('/Resources/l2dstill_3274_normal/l2dstill_3274_normal.model3.json', { autoInteract: false }).then((model) => {
      app.stage.addChild(model)
      model.anchor.set(0.5, 0.5)
      model.position.set(185, 250)
      model.scale.set(0.15, 0.15)
      
      model.internalModel.motionManager.startRandomMotion('Idle');


    })
  }, [])

  return <canvas id="canvas" style={{marginTop: '-100px'}}/>
}

export default Live2DAvatar
